'use client';

import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { FC, useState } from 'react';
import Loader from '~/components/loading';
import TabsNavigation from '~/components/tabs';
import WYSIWYGContent from '~/components/wysiwyg-content';
import Address from '~/data/strapi/types/shared-components/address';
import CommonData from '~/data/strapi/types/single-types/common-data';
import { RegionLocale } from '~/infra/locale';
import { CITIES } from '~/layouts/app-layout/components/header/city/constants';

import styles from './styles.module.css';

const YandexMap = dynamic(() => import('./map'), {
  ssr: false,
  loading: () => <Loader />,
});

interface Props {
  commonData: CommonData;
  locale: RegionLocale;
}

const MapNavigation: FC<Props> = ({ commonData, locale }) => {
  const cityTitle = CITIES.find((city) => city.id === locale)?.title;
  const addresses = [...(commonData.addresses ?? [])].sort(
    (a, b) => Number(b.title === cityTitle) - Number(a.title === cityTitle)
  );

  const [selectedAddress, setSelectedAddress] = useState<Address | null>(addresses[0] ?? null);

  const description = selectedAddress?.description;

  return (
    <>
      <div className={styles.addressContainer}>
        {addresses.length > 0 && (
          <TabsNavigation
            tabs={addresses}
            onChange={(a) => {
              setSelectedAddress(a);
            }}
            value={selectedAddress}
          />
        )}
        {description && <WYSIWYGContent html={description} />}
      </div>

      <div className={clsx(styles.mapContainer, 'yandex-map-container')}>
        <YandexMap selectedAddress={selectedAddress} />
      </div>
    </>
  );
};

export default MapNavigation;
